import { SimpleRestModel } from 'lib/services';
import { HttpApi } from 'services/HttpApi';

export const GroupModel = SimpleRestModel({
  HttpApi: HttpApi,
  collectionName: 'groups',
  modelName: 'GroupModel',
});
